import { render, staticRenderFns } from "./EventFrame.vue?vue&type=template&id=e2de95ec&"
import script from "./EventFrame.vue?vue&type=script&lang=js&"
export * from "./EventFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports